<template>
  <main class="page-content mb-auto w-100 text-center" aria-label="Content">
    <div class="section-wrap">
      <div class="section-content">
        <section class="section">
          <ValidationObserver v-slot="{ handleSubmit  }">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <div class="header">
                <h1>Trage deinen Lieblingsladen manuell ein.</h1>
              </div>
              <div class="content">
                <div class="row content-center-group">
                  <div
                    class="p-0"
                  >Das hilft uns danach den Laden ausfindig zu machen und in unser System einzutragen.</div>

                  <div class="company-info w-100">
                    <div class="form-group mt-5">
                      <validation-provider rules="required" v-slot="{ errors }">
                        <input v-bind:class="[errors.length == 0 ? '' : 'input-error']" class="form-control mt-3" :placeholder="errors.length == 0? 'Name' : errors[0]" v-model="name" />
                      </validation-provider>
                      <validation-provider rules="required" v-slot="{ errors }">
                        <input class="form-control mt-3" v-bind:class="[errors.length == 0 ? '' : 'input-error']" :placeholder="errors.length == 0? 'Strasse' : errors[0]" v-model="address" />
                      </validation-provider>
                      <validation-provider rules="required" v-slot="{ errors }">
                        <input v-bind:class="[errors.length == 0 ? '' : 'input-error']" class="form-control mt-3" :placeholder="errors.length == 0? 'PLZ Ort' : errors[0]" v-model="postCode" />
                      </validation-provider>
                      <input
                        class="form-control mt-3"
                        placeholder="Telefonnummer"
                        v-model="phoneNumber"
                      />
                      <validation-provider rules="email" v-slot="{ errors }">
                        <input v-bind:class="[errors.length == 0 ? '' : 'input-error']"
                          class="form-control mt-3"
                          placeholder="Email"
                          v-model="emailAddress"
                        />
                        <span>
                          <font color="red">{{ errors[0] }}</font>
                        </span>
                      </validation-provider>
                      <router-link to="/companies/list"></router-link>
                    </div>
                  </div>
                </div>
                <div class="button-group align-items-center justify-content-center mt-3 mb-5">
                  <button
                    type="submit"
                    class="btn btn-primary"
                    style="width: 266px"
                  >Weiter</button>
                  <button
                    v-on:click="handleCancel"
                    class="btn btn-secondary"
                    style="width: 266px"
                  >Abbrechen</button>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/app";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Dieses Feld ist zwingend"
});
extend("email", {
  ...email,
  message: "Email ist ungültig"
});

let db = firebase.firestore();
let companiesRef = db.collection("companies");

export default {
  data: function() {
    return {
      name: "",
      address: "",
      phoneNumber: "",
      postCode: "",
      emailAddress: ""
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapGetters({
      loggedIn: "loggedIn"
    })
  },
  methods: {
     onSubmit: function(){
      this.handleSubmitNewCompany();
    },
    goToCompanyDonation: function(companyId) {
      this.$router.push({
        path: `/donation/companies/${companyId}/donate`,
        params: { companyId: companyId }
      });
    },

    createNewCompany: function() {
      let newComanyData = {
      name: this.name,
      address: this.address +
        ", " +
        this.postCode,
      phoneNumber: this.phoneNumber,
      emailAddress: this.emailAddress,
      postCode: this.postCode,
      userCreated: true
      };

      let $this = this;
      companiesRef
      .add(newComanyData)
      .then(function(newCompany) {
        $this.goToCompanyDonation(newCompany.id);
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      });
    },

    handleSubmitNewCompany: function() {
      this.createNewCompany();
    },

    handleCancel: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>